export default {
  LEARN_MORE: '45b97b39-1397-4bae-bee1-331937df0b8e',
};
